var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
var Board = function () {
    return (React.createElement(Style, null, "\uC0C1\uD488\uBB38\uC758 \uC900\uBE44\uC911 \uC785\uB2C8\uB2E4."));
};
var Style = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 300px;\n    font-size: 18px;\n    background: #fff;\n    color: #777;\n    border-bottom: 1px solid #ccc;\n"], ["\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 300px;\n    font-size: 18px;\n    background: #fff;\n    color: #777;\n    border-bottom: 1px solid #ccc;\n"])));
export default Board;
var templateObject_1;



//////////////////
// WEBPACK FOOTER
// ./src/detail/components/qna/board.tsx
// module id = 261
// module chunks = 0